import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `NOTIF-INBOX` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/notifications` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (hộp thông báo là danh sách dài có trạng thái đọc/chưa đọc — màn hình làm tốt hơn câu chữ).
 */
export const NOTIF_INBOX = {
  id: "NOTIF-INBOX",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    description:
      "ĐỌC hộp thư thông báo mà hệ thống đã gửi riêng CHO TÔI. KHÔNG phải nơi bật/tắt cài đặt thông báo (đó là ACCT-NOTIFY), và KHÔNG phải nhật ký thao tác của cả nhóm (đó là GRP-ACTIVITY).",
    examples: [
      "xem thông báo",
      "xem thong bao",
      "có thông báo gì mới không",
      "co thong bao gi moi khong",
      "đánh dấu đã đọc hết",
      "thông báo",
      // ——— 0105: thêm cho đủ 40 ———
      "danh dau da doc het",
      "thong bao",
      "mở hộp thông báo",
      "mo hop thong bao",
      "hôm nay có báo gì không?",
      "hom nay co bao gi khong",
      "xem các thông báo chưa đọc",
      "xem cac thong bao chua doc",
      "tôi bỏ lỡ thông báo nào không",
      "toi bo lo thong bao nao khong",
      "đọc thông báo của nhóm",
      "doc thong bao cua nhom",
      "danh sách thông báo",
      "danh sach thong bao",
      "vừa có báo gì vậy",
      "vua co bao gi vay",
      "xem lại các báo cũ",
      "xem lai cac bao cu",
      "đánh dấu tất cả là đã đọc",
      "danh dau tat ca la da doc",
      "báo mới",
      "bao moi",
      "còn thông báo nào chưa xem không",
      "con thong bao nao chua xem khong",
      "mở thông báo ra xem",
      "mo thong bao ra xem",
      "hộp thư báo của tôi",
      "hop thu bao cua toi",
      "kiểm tra thông báo giúp mình",
      "kiem tra thong bao giup minh",
      "xem tin báo trong app",
      "xem tin bao trong app",
      "có gì mới không",
      "co gi moi khong",
    ],
  },
  screen: "/notifications",
  screenShows: "notification_inbox",
  endpoints: [
    "GET /notifications",
    "PATCH /notifications/read-all",
    "PATCH /notifications/{id}/read",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở hộp thông báo của bạn nhé.",
  },
  journey: { after: ["GRP-ACTIVITY"] },
  help: { title: "Hộp thông báo", tryNow: "xem thông báo" },
} satisfies AiCapabilityPage;
